import React, { useState } from "react";
import {
    Col,
    Row,
    Container,
    Nav,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import classnames from "classnames";

//Process Images Import
import processImage1 from "../../../assets/images/process-01.png";
import processImage2 from "../../../assets/images/process-02.png";
import processImage3 from "../../../assets/images/process-03.png";

const HowItWorks = ({ type }) => {
    const [activeTab, setActiveTab] = useState("1");

    const tabChange = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <React.Fragment>
            <section className="section" style={{ marginBottom: '-50px' }}>
                <Container>
                    <Row className={`align-items-center ${type === "client" ? "g-5" : ""}`}>
                        <Col lg={6} className={type === "client" ? "order-lg-2" : "order-lg-1"}>
                            <div className="section-title me-5">
                                <h3 className="title">How the Hiring Process Works</h3>
                                <p className="text-muted">
                                    Here’s what you can expect when partnering with Matrix:
                                </p>
                                <Nav className="process-menu  flex-column nav-pills">
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "1" })}
                                        onClick={() => {
                                            tabChange("1");
                                        }}
                                        type="button"
                                    >
                                        <div className="d-flex">
                                            <div className="number flex-shrink-0">1</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Submit Your Resume</h5>
                                                <p className="text-muted">
                                                    Getting started is easy! Start by applying to one of our posted positions. You can also submit
                                                    your existing resume directly through our website, or—if you need a fresh, professional
                                                    resume—use our built-in Resume Builder to create one in minutes. Whether you’re updating
                                                    an old resume or starting from scratch, we’ve got the tools to help you shine.
                                                </p>
                                                <p className="text-muted">
                                                    You don’t need to wait for the perfect job listing—once you&#39;re in our system, we may contact
                                                    you for future opportunities that align with your background.
                                                </p>
                                                <p className="text-muted mb-0">
                                                    This is your first step toward exciting new opportunities—and we’re here to make it simple,
                                                    effective, and stress-free!
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "2" })}
                                        onClick={() => {
                                            tabChange("2");
                                        }}
                                        type="button"
                                    >
                                        <div className="d-flex">
                                            <div className="number flex-shrink-0">2</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Initial Screening</h5>
                                                <p className="text-muted mb-0">
                                                    A dedicated recruiter will review your resume and qualifications. If your background aligns with
                                                    current or upcoming openings, we’ll reach out for an initial conversation to better understand
                                                    your goals, skills, preferences, and work history.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "3" })}
                                        onClick={() => {
                                            tabChange("3");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">3</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Career Consultation</h5>
                                                <p className="text-muted mb-0">
                                                    We go beyond your resume. We’ll discuss your career path, industry experience, and ideal role.
                                                    It’s a personalized conversation that sets the foundation for a strong match.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "4" })}
                                        onClick={() => {
                                            tabChange("4");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">4</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Opportunity Match &amp; Presentation</h5>
                                                <p className="text-muted mb-0">
                                                    If there&#39;s a suitable opportunity, we’ll present your background to the client company. We only
                                                    submit candidates we believe are a strong match for the company’s role, culture, and
                                                    expectations—so if we’re presenting you, it means we’re confident in your fit.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "5" })}
                                        onClick={() => {
                                            tabChange("5");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">5</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Interview Preparation</h5>
                                                <p className="text-muted mb-0">
                                                    We help you prepare for the interview process, including insights into the company culture,
                                                    position expectations, and customized tips to help you present your best self. Our goal is to make
                                                    sure you feel prepared, confident, and supported.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "6" })}
                                        onClick={() => {
                                            tabChange("6");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">6</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Offer &amp; Negotiation</h5>
                                                <p className="text-muted mb-0">
                                                    When an offer is extended, we serve as your advocate—helping you evaluate the opportunity and
                                                    navigate negotiations if necessary. Our goal is to make sure both you and the employer feel it’s
                                                    the right fit.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "7" })}
                                        onClick={() => {
                                            tabChange("7");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">7</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Onboarding &amp; Transition Support</h5>
                                                <p className="text-muted mb-0">
                                                    Even after the offer is accepted, we’re still here. We’ll guide you through the onboarding process
                                                    and check in post-hire to ensure a smooth transition into your new role.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                </Nav>
                            </div>
                        </Col>
                        <Col lg={6} className={type === "client" ? "order-lg-1" : "order-lg-2"}>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <img src={processImage1} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                                <TabPane tabId="2">
                                    <img src={processImage2} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                                <TabPane tabId="3">
                                    <img src={processImage3} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default HowItWorks;
